import { render } from "./NewDeliveryPerson.vue?vue&type=template&id=0b97463c&scoped=true"
import script from "./NewDeliveryPerson.vue?vue&type=script&lang=js"
export * from "./NewDeliveryPerson.vue?vue&type=script&lang=js"

import "./NewDeliveryPerson.vue?vue&type=style&index=0&id=0b97463c&scoped=true&lang=css"

import exportComponent from "C:\\ClusterTrade\\NXM_CLUSTERTRADE\\nxm_clustertrade_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b97463c"]])

export default __exports__